// services/adminPayment.service.ts
import axiosInstance from ".";

interface UpdatePaymentStatusBody {
  status: "Pending" | "Completed" | "Failed" | "Refunded";
  refundDetails?: {
    refundId?: string;
    amount?: string; // Assuming string for Decimal128 over API
    reason?: string;
    refundedAt?: Date;
  };
}

// Get all payments
export const getAllPaymentsAPI = async () => {
  const response = await axiosInstance.get(`/admin/payments`);
  return response;
};

// Get a single payment by ID
export const getPaymentByIdAPI = async ({ id }: { id: string }) => {
  const response = await axiosInstance.get(`/admin/payments/${id}`);
  return response;
};

// Update payment status
export const updatePaymentStatusAPI = async ({ id, body }: { id: string; body: UpdatePaymentStatusBody }) => {
  const response = await axiosInstance.patch(`/admin/payments/${id}/status`, body);
  return response;
};
